import { render } from "./TransitionFade.vue?vue&type=template&id=3be99f46"
import script from "./TransitionFade.vue?vue&type=script&lang=js"
export * from "./TransitionFade.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__